import styled from '@emotion/styled';
import '../../../assets/colors.scss';
const HeaderQuoteDetailStyle = styled('div')`
    &.preview {
        padding-top: 64px;

        .sticky-active .box-multiple-title {
            top: 64px;
        }
    }

    .box-preview {
        background-color: rgb(255, 246, 223);
        position: fixed;
        width: 100%;
        z-index: 99;
        padding: 16px 0;
        font-size: 16px;
        top: 0;
        left: 0;

        .role {
            line-height: 20px;
            padding: 6px 0;
        }
    }

    .box-header {
        padding-top: 20px;
        // padding-bottom: 20px;
        font-weight: 700;
        font-size: 20px;
        background: #152643;
        color: #fff;

        .logo {
            max-width: 240px;
            img {
                max-width: 100%;
            }
        }

        .ref {
            padding-top: 10px;
            text-align: right;
            line-height: 1.3;
        }

        .promotion {
            display: flex;
            align-items: center;
            border: 2px solid;
            color: #1a91ff;
            border-radius: 6px;
            font-weight: 700;
            font-size: 21px;
            justify-content: center;
            min-height: 64px;
            padding: 8px 1rem;
            margin-top: 1rem;

            .iconCoins {
                margin-right: 1.5rem;
                font-size: 28px;
            }
        }
    }

    .banner {
        height: 200px;
        .img-banner {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
        .skeleton-image {
            width: 100%;
            height: 200px;
        }
    }

    @media screen and (max-width: 767px) {
        .box-preview {
            .role {
                display: none;
            }
        }
        .box-header {
            font-size: 16px;
            .ref {
                padding-top: 0px;
            }
        }

        .banner {
            height:auto;
            .img-banner {
                object-position: 0px;
                height: auto;
            }
        }
    }
`;
export default HeaderQuoteDetailStyle;
